import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Glossary from "@/pages/Glossary";
import { buildGlossaryJsonLd } from "@/lib/seo/glossaryJsonLd";

export const Route = createFileRoute("/zh-cn/knowledge-center/glossary/")({
  head: () => ({
    ...buildRouteHead("/zh-cn/knowledge-center/glossary"),
    scripts: buildGlossaryJsonLd("zh-cn", "/zh-cn/knowledge-center/glossary"),
  }),
  component: Glossary,
});
